<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="6">
                <h1 class="subtitle-1 grey--text mb-4">Raport încasări - câștiguri</h1>
            </v-col>
            <v-col cols="12" sm="6" class="text-right">
                <v-btn color="success" 
                    @click="getCashInWinningsAsXls"
                    :loading="downloadBtnLoading"
                >Decarcă fisier Excel <v-icon right dark>mdi-microsoft-excel</v-icon></v-btn> 
            </v-col>
        </v-row>
        <v-card class="pa-4">
        <v-row >
            <v-col class="d-flex" cols="12" sm="3">
                <date-range-picker
                    ref="picker"
                    v-model="dateRange"
                    @update="updateValues"
                    :locale-data="localeData"
                    :ranges="rangeHelper"
                >
                    <template #input="picker" style="display: block;">
                        <v-text-field 
                            label="Perioada"
                            :value="selectedPeriod"
                            :dummy="picker"
                            hide-details
                            prepend-icon="mdi-calendar"
                            dense
                        >
                        </v-text-field>
                    </template>
                </date-range-picker>
            </v-col>
            <v-col class="d-flex" cols="12" sm="3">
                <v-select
                    v-model="produseSelectateStore"
                    :items="produse"
                    item-text="gameName"
                    item-value="gameId"
                    small-chips
                    deletable-chips
                    label="Produse"
                    multiple
                    clearable
                    v-on:change="updateValues"
                    hide-details
                    dense
                >
                </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-select
                    v-model="managerCompaniesSelected"
                    :items="managerCompanies"
                    label="Companie"
                    item-text="companyName"
                    item-value="id"
                    hide-details
                    dense
                    :error="managerCompaniesSelectedError"
                ></v-select>
            </v-col>
            <v-col class="d-flex" cols="12" sm="3">
                <v-select
                    v-model="terminaleSelected"
                    :items="terminale"
                    label="Terminale"
                    item-text="name"
                    item-value="id"
                    clearable
                    v-on:change="updateValues"
                    dense
                    hide-details
                ></v-select>
            </v-col>
        </v-row>
        <v-row class="pt-0">
            <v-col class="d-flex" cols="12" sm="2">
               <v-checkbox
                v-model="ignoreShopTest"
                label="Ignoră agențiile de test"
                v-on:change="updateValues"
                dense
                hide-details
                ></v-checkbox>
            </v-col>
            <v-col class="d-flex" cols="12" sm="3">
               <v-checkbox
                v-model="useOra10"
                label="Folosește referința ora 10"
                v-on:change="updateValues"
                dense
                persistent-hint
                hint="Raportul conține încasările aferente perioadei selectate și câștigurile omologate în perioada selectată, până la ora 10:00 AM ziua următoare."
                ></v-checkbox>
            </v-col>
            <v-col class="d-flex" cols="12" sm="3">
                 <v-btn color="primary" 
                    @click="updateData"
                    :loading="reloadBtnLoading"
                ><v-icon left dark>mdi-reload</v-icon> Reîncarcă</v-btn> 
            </v-col>

        </v-row>
        </v-card>
        <v-alert 
            dense 
            dismissible
            border="left"
            colored-border
            type="info" 
            class="mt-4"
            elevation="2"
        >Dublu click pe un rand pentru detalii pe zile
        </v-alert>
        <v-row align="center">
            <v-col>
                <v-card>
                    <v-card-title>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        class="elevation-1"
                        :loading="tableLoading"
                        :text-loading="tableLoadingText"
                        :search="search"
                        :footer-props="{
                                'items-per-page-options': [10, 20, 30, 40, 50]
                            }"
                        :items-per-page="20"
                        @dblclick:row="showShopDetailed"
                    ></v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-model="shopDetailsDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-if="shopDetailsSelected"
        >
            <v-card>
                <v-card-title>
                <v-app-bar dark color="primary" fixed>
                <v-btn icon dark @click="shopDetailsDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ shopDetailsSelected['cod-agentie'] }} - {{ shopDetailsSelected['agentie'] }} <span class="font-weight-thin">| perioada</span> {{ this.dateRange.startDate | moment('YYYY-MM-DD') }} - {{ this.dateRange.endDate | moment('YYYY-MM-DD') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="success" 
                    @click="getCashInWinningsByShopCodeAsXls"
                    :loading="shopDetailsDownloadBtnLoading"
                >Decarcă fisier Excel <v-icon right dark>mdi-microsoft-excel</v-icon></v-btn> 
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="shopDetailsDialog = false">Închide</v-btn>
                </v-toolbar-items>
                </v-app-bar>
                </v-card-title>
                <v-card-text style="padding-top: 70px;">
                    
                    <v-data-table
                        :headers="shopDetailsHeaders"
                        :items="shopDetailsItems"
                        class="elevation-1"
                        :loading="shopDetailsTableLoading"
                        :text-loading="tableLoadingText"
                        :search="shopDetailsTableSearch"
                        :footer-props="{
                                'items-per-page-options': [10, 20, 30, 40, 50]
                            }"
                        :items-per-page="20"
                    ></v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    components: { DateRangePicker },
    data: function() {
        return {
            search: '',
            dateRange: {
                startDate: this.$moment().subtract(1, 'days').toISOString().substr(0, 10), 
                endDate: this.$moment().subtract(1, 'days').toISOString().substr(0, 10)
            },
            localeData: {
                format: 'yyyy-mm-dd',
            },
            tableLoading: true,
            tableLoadingText: "Se încarcă... Te rog așteaptă",
            raportTypeSelectat: null,
            terminale: [
                {id: 0, name: 'Inclusiv terminale'},
                {id: 1, name: 'Fară terminale'},
                {id: 2, name: 'Doar terminale'}
            ],
            terminaleSelected: null,
            produseSelectateStore: [],
            useOra10: true,
            ignoreShopTest: true,
            downloadBtnLoading: false,
            managerCompaniesSelected: null, 
            managerCompaniesSelectedError: false,
            shopDetailsDialog: false,   
            shopDetailsSelected: null,
            shopDetailsTableLoading: false,
            shopDetailsTableSearch: '',
            shopDetailsHeaders: [],
            shopDetailsItems: [],
            shopDetailsDownloadBtnLoading: false,
        }
    },
    computed: {
        headers(){
            return this.$store.getters['raportIncasariCastiguri/getHeaders'];
        },
        items(){
            return this.$store.getters['raportIncasariCastiguri/getItems'];
        },
        produse(){
            return this.$store.getters['getProduse'];
        },
        selectedPeriod(){
            return this.$moment(this.dateRange.startDate).format('YYYY-MM-DD') + ' - ' + this.$moment(this.dateRange.endDate).format('YYYY-MM-DD');
        },
        produseSelectate(){
            if(this.produseSelectateStore.length == 0){
                let response = [];
                this.produse.forEach(element => {
                    response.push(element.gameId);
                });
                return response;
            }else{
                return this.produseSelectateStore;
            }
        },
        managerCompanies(){
            return this.$store.getters['getManagerCompanies'];
        },
        rangeHelper(){
            let today = new Date()
            today.setHours(0, 0, 0, 0)

            let yesterday = new Date()
            yesterday.setDate(today.getDate() - 1)
            yesterday.setHours(0, 0, 0, 0);

            let thisMonthStart = this.$moment().startOf('month');
            let thisMonthEnd = this.$moment().endOf('month');

            return {
                'Azi': [today, today],
                'Ieri': [yesterday, yesterday],
                'Luna curentă': [thisMonthStart, thisMonthEnd],
                'Anul curent': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
                'Luna trecută': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
            };

        }
    },
    watch: { // select fist item from managerCompanies array if no option is selected (managerCompaniesSelected = null)
        managerCompanies: function() {
            if(!this.managerCompaniesSelected){
                this.managerCompaniesSelected = this.managerCompanies[0].id;
            }
        }
    },
    mounted() {
        this.updateData();
        console.log(this.$moment);
    },
    methods: {
        updateData(){
            
            this.tableLoading = true;
            this.$store.dispatch('raportIncasariCastiguri/getCashInWinnings', {
                dateFrom: this.$moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                dateTo: this.$moment(this.dateRange.endDate).format('YYYY-MM-DD'),
                games: this.produseSelectate,
                type: this.terminaleSelected,
                useOra10: this.useOra10,
                ignoreShopTest: this.ignoreShopTest,

            }).then(()=>{
                this.tableLoading = false;
            });
        },
        updateValues(){
            this.updateData();
        },
        getCashInWinningsAsXls(){
            this.downloadBtnLoading = true;
            this.$store.dispatch('raportIncasariCastiguri/getCashInWinningsAsXls',{
                dateFrom: this.$moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                dateTo: this.$moment(this.dateRange.endDate).format('YYYY-MM-DD'),
                games: this.produseSelectate,
                type: this.terminaleSelected,
                useOra10: this.useOra10,
                ignoreShopTest: this.ignoreShopTest,
            }).then(()=>{
                this.downloadBtnLoading = false;
            })
        },
        showShopDetailed(event, row){
            
            if (window.getSelection){
                window.getSelection().removeAllRanges();
            }else if (document.selection){
                document.selection.empty();
            }

            this.shopDetailsHeaders = [];
            this.shopDetailsItems = [];

            this.shopDetailsSelected = row.item;
            this.shopDetailsDialog = true;
            this.shopDetailsTableLoading = true;
            
            this.$store.dispatch('raportIncasariCastiguri/getCashInWinningsByShopCode',{
                dateFrom: this.$moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                dateTo: this.$moment(this.dateRange.endDate).format('YYYY-MM-DD'),
                games: this.produseSelectate,
                useOra10: this.useOra10,
                shopCode: this.shopDetailsSelected['cod-agentie'],
            }).then((response)=>{
                this.shopDetailsHeaders = response.headers;
                this.shopDetailsItems = response.items;
                this.shopDetailsTableLoading = false;
            });
            
        },
        getCashInWinningsByShopCodeAsXls(){
            this.shopDetailsDownloadBtnLoading = true;
            this.$store.dispatch('raportIncasariCastiguri/getCashInWinningsByShopCodeAsXls',{
                dateFrom: this.$moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                dateTo: this.$moment(this.dateRange.endDate).format('YYYY-MM-DD'),
                games: this.produseSelectate,
                useOra10: this.useOra10,
                shopCode: this.shopDetailsSelected['cod-agentie'],
            }).then(()=>{
                this.shopDetailsDownloadBtnLoading = false;
            })
        },
    },
}
</script>

<style>
.v-data-table {
    max-width: 100%
}
.reportrange-text {
    border: none !important; 
    padding-left: 0 !important;
}
.vue-daterange-picker {
    display: block !important;
    width: 100% !important;
}
</style>